import keyMirror from 'keymirror';

export default keyMirror({
    LOAD_LANGUAGE: null,
});
